import { addProtocolIfMissing } from '../../helpers/addProtocolIfMissing';

export const DocIframe = ({ src } : { src: string }) => {
  return <div className='osirus-agent-panel-frame'>
    <iframe 
      title={src}
      allowFullScreen
      height='100%'
      width='100%'
      src={addProtocolIfMissing(src)}
    />   
  </div>
}